// extracted by mini-css-extract-plugin
export default {"tabContainer":"financialStatement_tabContainer__uzUYl","tabs":"financialStatement_tabs__6TDcZ","tabItem":"financialStatement_tabItem__gK47p"};